import type { TokenUsage } from "@kitsulab/schema";

const PREFIX_TO_USAGE: Record<string, TokenUsage> = {
	radius: "radius",
	spacing: "spacing",
	border: "border",
	font: "Font",
};

function inferUsage(name: string): TokenUsage {
	const prefix = name.split(".")[0] ?? "";
	const mapped = PREFIX_TO_USAGE[prefix];
	if (mapped) return mapped;
	return "color";
}

export function migrateThemeTokens(
	tokens: Record<string, unknown> | null | undefined,
): Record<string, unknown> {
	if (!tokens) return {};
	const out: Record<string, unknown> = {};
	for (const [name, token] of Object.entries(tokens)) {
		if (token && typeof token === "object") {
			const t = token as Record<string, unknown>;
			if (typeof t.usage === "string") {
				out[name] = token;
			} else {
				out[name] = { ...t, usage: inferUsage(name) };
			}
		} else {
			out[name] = token;
		}
	}
	return out;
}
